<template>
  <section
    class="cabinet cabinet-achieve"
    v-if="Achievements && Achievements.achievements"
  >
    <div class="cabinet-header _mb-8">
      <div class="cabinet-header__text _mr-4 _mr-sm-0 _mb-sm-8">
        <div class="_mb-4 _fs-24 _lh-32 _fw-700 _tc-dark">
          {{ $t('cabinet.dashboard.sections[2].title') }}
        </div>
        <div class="_fs-16 _lh-24">
          {{ $t('cabinet.dashboard.sections[2].descr') }}
        </div>
      </div>
      <div class="cabinet-header__stat _ml-4 _ml-sm-0">
        <div class="cabinet-header__stat-el _mr-8 _mr-sm-7">
          <div class="cabinet-header__icon _mr-4">
            <img :src="require('@/assets/img/cabinet/cup_icon.png')" />
          </div>
          <div
            class="cabinet-header__num"
            v-if="Achievements && Achievements.achievements"
          >
            <div class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _fw-600 _tc-dark">
              {{ Achievements.achievements.captured
              }}<span
                class="_fs-24 _fs-sm-18 _lh-28 _lh-sm-20 _fw-600 _tc-grey-light"
                >/{{ Achievements.achievements.total }}</span
              >
            </div>
            <div class="_fs-16 _fs-sm-14 _lh-24 _lh-sm-20 _tc-dark">
              {{
                $tc(
                  'cabinet.dashboard.cards[2].tip',
                  Achievements.achievements.captured
                )
              }}
            </div>
          </div>
        </div>
        <div class="cabinet-header__stat-el" v-if="false">
          <div class="cabinet-header__icon _mr-4">
            <img :src="require('@/assets/img/cabinet/coins_icon.png')" />
          </div>
          <div
            class="cabinet-header__num"
            v-if="Achievements && Achievements.rewards"
          >
            <div class="_fs-32 _fs-sm-24 _lh-38 _lh-sm-32 _fw-600 _tc-dark">
              {{ Achievements.rewards.captured
              }}<span
                class="_fs-24 _fs-sm-18 _lh-28 _lh-sm-20 _fw-600 _tc-grey-light"
                >/{{ Achievements.rewards.total }}</span
              >
            </div>
            <div class="_fs-16 _fs-sm-14 _lh-24 _lh-sm-20 _tc-dark">
              {{
                $tc(
                  'cabinet.dashboard.cards[1].tip',
                  Achievements.rewards.captured
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cabinet-achieve__blocks">
      <div class="achieve achieve__container">
        <div class="achieve-head">
          <div
            class="achieve-category _fs-20 _fs-sm-16 _lh-sm-18 _lh-24 _fw-600 _mr-2"
            @click="IntensivesClick()"
          >
            {{ $t('cabinet.dashboard.sections[2].groups[0].title') }}
          </div>
          <div class="achieve-icon">
            <div class="achieve-icon__item _mr-4">
              <div class="achieve-icon__img _mr-1">
                <img :src="require('@/assets/img/cabinet/cup_icon-mini.png')" />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  achievements.intensives.filter((el) => el.active).length
                }}</span>
                <span class="achieve-total"
                  >/{{ achievements.intensives.length }}
                </span>
              </div>
            </div>
            <div class="achieve-icon__item" v-if="false">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/coin_icon-mini.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  Intensives.rewards.captured
                }}</span>
                <span class="achieve-total"
                  >/{{ Intensives.rewards.total }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="achieve-grid _mt-6">
          <div
            class="achieve__item"
            v-for="(intensive, i) in achievements.intensives"
            :class="{ achieve__item_disabled: !intensive.active }"
            :key="`int_${i}`"
          >
            <div class="achieve__item-img">
              <img
                :src="
                  require(`@/assets/img/cabinet/achieve/${
                    intensive.active ? '' : 'grey-'
                  }${intensive.image}.png`)
                "
                alt="achieve"
              />
            </div>
            <div
              class="achieve__item-title _mt-2"
              :class="{ 'gray-color': !intensive.active }"
            >
              {{ intensive.title }}
            </div>
            <div
              class="achieve__item-subtitle _mt-2"
              :class="{ 'gray-color': !intensive.active }"
            >
              {{ intensive.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="achieve achieve__container _mt-12">
        <div class="achieve-head">
          <div
            class="achieve-category _fs-20 _fs-sm-16 _lh-sm-18 _lh-24 _fw-600 _mr-2"
            @click="WebinarsClick()"
          >
            {{ $t('cabinet.dashboard.sections[2].groups[1].title') }}
          </div>
          <div class="achieve-icon">
            <div class="achieve-icon__item _mr-4">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/cup_icon-mini-2.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  achievements.webinars.filter((el) => el.active).length
                }}</span>
                <span class="achieve-total"
                  >/{{ achievements.webinars.length }}
                </span>
              </div>
            </div>
            <div class="achieve-icon__item" v-if="false">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/coin_icon-mini.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  Webinars.rewards.captured
                }}</span>
                <span class="achieve-total"
                  >/{{ Webinars.rewards.total }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="achieve-grid _mt-6">
          <div
            class="achieve__item"
            v-for="(webinar, i) in achievements.webinars"
            :key="`web_${i}`"
          >
            <div class="achieve__item-img">
              <img
                :src="
                  require(`@/assets/img/cabinet/achieve/${
                    webinar.active ? '' : 'grey-'
                  }${webinar.image}.png`)
                "
                alt="achieve"
              />
            </div>
            <div
              class="achieve__item-title _mt-2"
              :class="{ 'gray-color': !webinar.active }"
            >
              {{ webinar.title }}
            </div>
            <div
              class="achieve__item-subtitle _mt-2"
              :class="{ 'gray-color': !webinar.active }"
            >
              {{ webinar.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="achieve achieve__container _mt-12">
        <div class="achieve-head">
          <div
            class="achieve-category _fs-20 _fs-sm-16 _lh-sm-18 _lh-24 _fw-600 _mr-2"
            @click="TrainingsClick()"
          >
            {{ $t('cabinet.dashboard.sections[2].groups[2].title') }}
          </div>
          <div class="achieve-icon">
            <div class="achieve-icon__item _mr-4">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/cup_icon-mini-3.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  achievements.trainings.filter((el) => el.active).length
                }}</span>
                <span class="achieve-total"
                  >/{{ achievements.trainings.length }}
                </span>
              </div>
            </div>
            <div class="achieve-icon__item" v-if="false">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/coin_icon-mini.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  Trainings.rewards.captured
                }}</span>
                <span class="achieve-total"
                  >/{{ Trainings.rewards.total }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="achieve-grid _mt-6">
          <div
            class="achieve__item"
            v-for="(training, i) in achievements.trainings"
            :key="`train_${i}`"
          >
            <div class="achieve__item-img">
              <img
                :src="
                  require(`@/assets/img/cabinet/achieve/${
                    training.active ? '' : 'grey-'
                  }${training.image}.png`)
                "
                alt="achieve"
              />
            </div>
            <div
              class="achieve__item-title _mt-2"
              :class="{ 'gray-color': !training.active }"
            >
              {{ training.title }}
            </div>
            <div
              class="achieve__item-subtitle _mt-2"
              :class="{ 'gray-color': !training.active }"
            >
              {{ training.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="achieve achieve__container _mt-12">
        <div class="achieve-head">
          <div
            class="achieve-category _fs-20 _fs-sm-16 _lh-sm-18 _lh-24 _fw-600 _mr-2"
            @click="PodcastsClick()"
          >
            {{ $t('cabinet.dashboard.sections[2].groups[3].title') }}
          </div>
          <div class="achieve-icon">
            <div class="achieve-icon__item _mr-4">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/cup_icon-mini-4.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  achievements.podcasts.filter((el) => el.active).length
                }}</span>
                <span class="achieve-total"
                  >/{{ achievements.podcasts.length }}
                </span>
              </div>
            </div>
            <div class="achieve-icon__item" v-if="false">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/coin_icon-mini.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  Podcasts.rewards.captured
                }}</span>
                <span class="achieve-total"
                  >/{{ Podcasts.rewards.total }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="achieve-grid _mt-6">
          <div
            class="achieve__item"
            v-for="(podcast, i) in achievements.podcasts"
            :key="`pod_${i}`"
          >
            <div class="achieve__item-img">
              <img
                :src="
                  require(`@/assets/img/cabinet/achieve/${
                    podcast.active ? '' : 'grey-'
                  }${podcast.image}.png`)
                "
                alt="achieve"
              />
            </div>
            <div
              class="achieve__item-title _mt-2"
              :class="{ 'gray-color': !podcast.active }"
            >
              {{ podcast.title }}
            </div>
            <div
              class="achieve__item-subtitle _mt-2"
              :class="{ 'gray-color': !podcast.active }"
            >
              {{ podcast.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="achieve achieve__container _mt-12">
        <div class="achieve-head">
          <div
            class="achieve-category _fs-20 _fs-sm-16 _lh-sm-18 _lh-24 _fw-600 _mr-2"
            @click="SuccessAcademyClick()"
          >
            {{ $t('cabinet.dashboard.sections[2].groups[4].title') }}
          </div>
          <div class="achieve-icon">
            <div class="achieve-icon__item _mr-4">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/cup_icon-mini-5.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  achievements.academy.filter((el) => el.active).length
                }}</span>
                <span class="achieve-total"
                  >/{{ achievements.academy.length }}
                </span>
              </div>
            </div>
            <div class="achieve-icon__item" v-if="false">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/coin_icon-mini.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  Academy.rewards.captured
                }}</span>
                <span class="achieve-total">/{{ Academy.rewards.total }} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="achieve-grid _mt-6">
          <div
            class="achieve__item"
            v-for="(academy, i) in achievements.academy"
            :key="`ac_${i}`"
          >
            <div class="achieve__item-img">
              <img
                :src="
                  require(`@/assets/img/cabinet/achieve/${
                    academy.active ? '' : 'grey-'
                  }${academy.image}.png`)
                "
                alt="achieve"
              />
            </div>
            <div
              class="achieve__item-title _mt-2"
              :class="{ 'gray-color': !academy.active }"
            >
              {{ academy.title }}
            </div>
            <div
              class="achieve__item-subtitle _mt-2"
              :class="{ 'gray-color': !academy.active }"
            >
              {{ academy.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="achieve achieve__container _mt-12">
        <div class="achieve-head">
          <div
            class="_tc-dark-grey _fs-20 _fs-sm-16 _lh-sm-18 _lh-24 _fw-600 _mr-2"
          >
            {{ $t('cabinet.dashboard.sections[2].groups[5].title') }}
          </div>
          <div class="achieve-icon">
            <div class="achieve-icon__item _mr-4">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/cup_icon-mini-6.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  achievements.activity.filter((el) => el.active).length
                }}</span>
                <span class="achieve-total"
                  >/{{ achievements.activity.length }}
                </span>
              </div>
            </div>
            <div class="achieve-icon__item" v-if="false">
              <div class="achieve-icon__img _mr-1">
                <img
                  :src="require('@/assets/img/cabinet/coin_icon-mini.png')"
                />
              </div>
              <div class="achieve-icon__num _fs-16 _lh-24 _fw-500 _tc-dark">
                <span class="achieve-current">{{
                  Activity.rewards.captured
                }}</span>
                <span class="achieve-total"
                  >/{{ Activity.rewards.total }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="achieve-grid _mt-6">
          <div
            class="achieve__item"
            v-for="(activity, i) in achievements.activity"
            :key="`ac_${i}`"
          >
            <div class="achieve__item-img">
              <img
                :src="
                  require(`@/assets/img/cabinet/achieve/${
                    activity.active ? '' : 'grey-'
                  }${activity.image}.png`)
                "
                alt="achieve"
              />
            </div>
            <div
              class="achieve__item-title _mt-2"
              :class="{ 'gray-color': !activity.active }"
            >
              {{ activity.title }}
            </div>
            <div
              class="achieve__item-subtitle _mt-2"
              :class="{ 'gray-color': !activity.active }"
            >
              {{ activity.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  metaInfo() {
    return { title: this.$t('cabinet.dashboard.menu[3]') }
  },
  name: 'CabinetAchievements',
  computed: {
    ...mapGetters(['user', 'Achievements']),
    Intensives() {
      return this.Achievements?.groups?.find((el) => el.slug === 'intensives')
    },
    Webinars() {
      return this.Achievements?.groups?.find((el) => el.slug === 'webinars')
    },
    Trainings() {
      return this.Achievements?.groups?.find((el) => el.slug === 'trainings')
    },
    Podcasts() {
      return this.Achievements?.groups?.find((el) => el.slug === 'podcasts')
    },
    Academy() {
      return this.Achievements?.groups?.find(
        (el) => el.slug === 'success-academy'
      )
    },
    Activity() {
      return this.Achievements?.groups?.find(
        (el) => el.slug === 'platform-activities'
      )
    },
    achievements() {
      return {
        intensives: [
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[0].achieveTitle[0]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[0].achieveDescr[0]'
            ),
            coins: 15,
            image: 'intensives-1',
            active: this.Intensives?.achievements?.find(
              (el) => el.slug === 'intensive-fan'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[0].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[0].achieveDescr[1]'
            ),
            coins: 15,
            image: 'intensives-2',
            active: this.Intensives?.achievements?.find(
              (el) => el.slug === 'intensive-expert'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[0].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[0].achieveDescr[2]'
            ),
            coins: 15,
            image: 'intensives-3',
            active: this.Intensives?.achievements?.find(
              (el) => el.slug === 'intensive-conqueror'
            ).is_captured,
          },
        ],
        webinars: [
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[1].achieveTitle[0]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[1].achieveDescr[0]'
            ),
            coins: 15,
            image: 'webinars-1',
            active: this.Webinars?.achievements?.find(
              (el) => el.slug === 'webinar-fan'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[1].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[1].achieveDescr[1]'
            ),
            coins: 15,
            image: 'webinars-2',
            active: this.Webinars?.achievements?.find(
              (el) => el.slug === 'webinar-expert'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[1].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[1].achieveDescr[2]'
            ),
            coins: 15,
            image: 'webinars-3',
            active: this.Webinars?.achievements?.find(
              (el) => el.slug === 'webinar-conqueror'
            ).is_captured,
          },
        ],
        trainings: [
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[2].achieveTitle[0]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[2].achieveDescr[0]'
            ),
            coins: 15,
            image: 'trainings-1',
            active: this.Trainings?.achievements?.find(
              (el) => el.slug === 'training-fan'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[2].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[2].achieveDescr[1]'
            ),
            coins: 15,
            image: 'trainings-2',
            active: this.Trainings?.achievements?.find(
              (el) => el.slug === 'training-expert'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[2].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[2].achieveDescr[2]'
            ),
            coins: 15,
            image: 'trainings-3',
            active: this.Trainings?.achievements?.find(
              (el) => el.slug === 'training-conqueror'
            ).is_captured,
          },
        ],
        podcasts: [
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveTitle[0]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveDescr[0]'
            ),
            coins: 15,
            image: 'podcasts-1',
            active: this.Podcasts?.achievements?.find(
              (el) => el.slug === 'podcast-fan'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveDescr[1]'
            ),
            coins: 15,
            image: 'podcasts-2',
            active: this.Podcasts?.achievements?.find(
              (el) => el.slug === 'podcast-connoisseur'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveDescr[2]'
            ),
            coins: 15,
            image: 'podcasts-3',
            active: this.Podcasts?.achievements?.find(
              (el) => el.slug === 'podcast-expert'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveTitle[3]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[3].achieveDescr[3]'
            ),
            coins: 15,
            image: 'podcasts-4',
            active: this.Podcasts?.achievements?.find(
              (el) => el.slug === 'podcast-conqueror'
            ).is_captured,
          },
        ],
        academy: [
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[0]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[0]'
            ),
            coins: 15,
            image: 'academy-marketing',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-marketing'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[1]'
            ),
            coins: 15,
            image: 'academy-product',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-products'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[2]'
            ),
            coins: 15,
            image: 'academy-i',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-me'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[3]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[3]'
            ),
            coins: 15,
            image: 'academy-company',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-company'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[4]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[4]'
            ),
            coins: 15,
            image: 'academy-business',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-growth'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[5]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[5]'
            ),
            coins: 15,
            image: 'academy-achieve',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-achievements'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveTitle[6]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[4].achieveDescr[6]'
            ),
            coins: 15,
            image: 'academy-biznes',
            active: this.Academy?.achievements?.find(
              (el) => el.slug === 'success-academy-biznes'
            ).is_captured,
          },
        ],
        activity: [
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[0]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[0]'
            ),
            coins: 15,
            image: 'success-wall',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-success-wall'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[1]'
            ),
            coins: 15,
            image: 'usefull',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-helpful-resources'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[1]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[2]'
            ),
            coins: 15,
            image: 'network',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-network-security'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[3]'
            ),
            coins: 15,
            image: '3days',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-3-days-in-row'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[4]'
            ),
            coins: 15,
            image: '7days',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-7-days-in-row'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[5]'
            ),
            coins: 15,
            image: '14days',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-14-days-in-row'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[6]'
            ),
            coins: 15,
            image: '30days',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-30-days-in-row'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[2]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[7]'
            ),
            coins: 15,
            image: '60days',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-60-days-in-row'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[3]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[8]'
            ),
            coins: 15,
            image: 'top',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-in-top'
            ).is_captured,
          },
          {
            title: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveTitle[4]'
            ),
            description: this.$t(
              'cabinet.dashboard.sections[2].groups[5].achieveDescr[9]'
            ),
            coins: 15,
            image: 'top2',
            active: this.Activity?.achievements?.find(
              (el) => el.slug === 'platform-activities-in-top-few-times-in-row'
            ).is_captured,
          },
        ],
      }
    },
  },
  methods: {
    ...mapActions(['fetchAchievements']),
    IntensivesClick() {
      this.$router.push(this.helpers.buildRoute({ name: 'Intensives' }))
    },
    WebinarsClick() {
      this.$router.push(this.helpers.buildRoute({ name: 'Webinars' }))
    },
    TrainingsClick() {
      this.$router.push(this.helpers.buildRoute({ name: 'Trainings' }))
    },
    SuccessAcademyClick() {
      this.$router.push(this.helpers.buildRoute({ name: 'SuccessAcademy' }))
    },
    PodcastsClick() {
      this.$router.push(
        this.helpers.buildRoute({
          name: 'SuccessAcademySections',
          params: { slug: 'invitation-business-podcast' },
        })
      )
    },
  },
  async mounted() {
    await this.fetchAchievements()
  },
}
</script>

<style lang="scss">
.cabinet {
  &-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media screen and (max-width: 1220px) {
      align-items: flex-end;
    }
    @media screen and (max-width: 743px) {
      flex-direction: column;
      align-items: flex-start;
    }
    &__text {
      width: 50%;
      @media screen and (max-width: 743px) {
        width: 100%;
      }
    }
    &__stat {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-el {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    &__icon {
      width: 100px;
      height: 100px;
      border: 1px solid #d1d2cd;
      border-radius: 99px;
      @media screen and (max-width: 1220px) {
        width: 74px;
        height: 74px;
      }
      @media screen and (max-width: 743px) {
        width: 60px;
        height: 60px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
}
.cabinet-achieve {
  .achieve {
    &-head {
      display: flex;
    }
    &-category {
      cursor: pointer;
      color: #69b3e7;
      &:hover {
        text-decoration: underline;
      }
    }
    &-icon {
      display: flex;
      flex-direction: row;
      &__item {
        display: flex;
        align-items: center;
      }
    }
    &-total {
      color: #b2b4b2;
    }
    &-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 32px;
      @media screen and (max-width: 1220px) {
        overflow-x: auto;
        overflow-y: hidden;
        grid-template-columns: repeat(10, 1fr);
        padding-bottom: 16px;
      }
    }
    &__item {
      width: 176px;
      height: 272px;
      @media screen and (max-width: 767px) {
        width: 140px;
        height: 173px;
      }
      &-title {
        text-align: center;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 16px;
        }
      }
      &-subtitle {
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 16px;
        }
      }
      &-title.gray-color,
      &-subtitle.gray-color {
        color: #707372;
      }
      &-img {
        height: 176px;
        width: 176px;
        @media screen and (max-width: 767px) {
          margin: 0 auto;
          height: 93px;
          width: 93px;
        }
        img {
          width: 100%;
          height: auto;
          object-fit: cover;
          object-position: center;
        }
      }
    }
  }
}
</style>
